export const handleSides: Array<'left' | 'right'> = ['left', 'right'];
